'use client';

import { cn } from '@savvy-kit/lib/utils';

import type { ToolbarTopSlotProps } from '../../types/toolbar-slot-props';

export type DataTableToolbarTopProps = ToolbarTopSlotProps;

export function DataTableToolbarTop({ children, className }: DataTableToolbarTopProps) {
  return <div className={cn('flex flex-col gap-4 py-4', className)}>{children}</div>;
}
